export const mapStringInputsToNumber = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  data: T,
  inputs: readonly K[]
) => {
  const result = {};

  for (const field of inputs) {
    if (field in data && data[field] !== null) {
      Object.assign(result, {
        [field]: Number(data[field]),
      });
    }
  }

  return result as { [P in K]: number };
};

export const mapNumberInputsToString = <
  T extends Record<string, unknown>,
  K extends keyof T
>(
  data: T,
  inputs: readonly K[]
) => {
  const result = {};

  for (const field of inputs) {
    if (field in data) {
      Object.assign(result, {
        [field]: String(data[field]),
      });
    }
  }

  return result as { [P in K]: number };
};
